import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KeywordsPage from "@/pages/keywords/page";
import CategoryPage from "@/pages/category/page";
import EntryPage from "@/pages/entry/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/keywords",
    element: <KeywordsPage />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/entry/:id",
    element: <EntryPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;